<template lang="pug">
  v-container.pa-0(style="max-width:600px")
    v-layout.py-4.ml-4
      div.mr-2
        v-icon.mt-1(left color="black" :size="24" @click="back") mdi-arrow-left
      div.title.font-weight-bold Payouts
    //- Loading state
    v-layout.py-6(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
    //- Listing
    div.pa-0.main-container(v-else)
      v-tabs(v-model="tab" fixed-tabs color="textColorAccent" height="40" slider-size="4" @change="checkTab")
        v-tab.button-AA-small.px-0 To Process
          span.ml-1(v-if="toProcessCount") ({{ toProcessCount }})
        v-tab.button-AA-small.px-0 Processing
          span.ml-1(v-if="processingCount") ({{ processingCount }})
        v-tab.button-AA-small.px-0 Completed
      div.separator(:style="{ 'background-color':$vuetify.theme.themes[$theme].basic600T16 }")
      div
        v-tabs-items(v-model="tab" touchless)
          v-tab-item
            payout-to-process(v-if="tab === 0" :company="company" :companyTiers="companyTiers" :toProcessCount.sync="toProcessCount" @nextTab="nextTab")
          v-tab-item
            payout-processing(v-if="tab === 1" :company="company" :companyTiers="companyTiers" :processingCount.sync="processingCount")
          v-tab-item
            payout-completed(v-if="tab === 2" :company="company" :companyTiers="companyTiers")          
</template>

<script>
import { mapGetters } from 'vuex'
import PayoutToProcess from '@/components/resellers/payouts/PayoutToProcess.vue'
import PayoutProcessing from '@/components/resellers/payouts/PayoutProcessing.vue'
import PayoutCompleted from '@/components/resellers/payouts/PayoutCompleted.vue'

export default {
  name: 'ResellerPayouts',
  components: {
    PayoutToProcess,
    PayoutProcessing,
    PayoutCompleted
  },
  data: () => ({
    isFetching: false,
    companyTiers: [],
    tab: 0,
    toProcessCount: 0,
    processingCount: 0
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    fetchToProcessUrl() {
      return `members/commissions/?company=${this.company.id}`
    },
    fetchProcessingUrl() {
      return `members/payouts/?company=${this.company.id}&status=processed`
    },
    fetchCompanyTiersUrl() {
      return `/companies/${this.company.id}/tiers`
    }
  },
  async mounted() {
    this.checkTab()
    try {
      this.isFetching = true
      await Promise.all([this.fetchToProcessCounts(), this.fetchProcessingCounts(), this.fetchCompanyTiers()])
      this.isFetching = false
    } catch (error) {
      this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
    }
  },
  methods: {
    fetchToProcessCounts() {
      return this.axios
        .get(this.fetchToProcessUrl)
        .then(resp => {
          this.toProcessCount = resp.data.count
        })
    },
    fetchProcessingCounts() {
      return this.axios
        .get(this.fetchProcessingUrl)
        .then(resp => {
          this.processingCount = resp.data.count
        })
    },
    fetchCompanyTiers() {
      this.isFetching = true
      return this.axios
        .get(this.fetchCompanyTiersUrl)
        .then(resp => {
          this.companyTiers = [...resp.data.tiers]
          this.isFetching = false
        })
    },
    back() {
      this.$router.replace({ query: null }).catch(() => {})
      this.$router.push('/admin/resellers')
    },
    checkTab() {
      let hash
      switch (this.tab) {
        case 0:
          hash = '#toProcess'
          break

        case 1:
          hash = '#processing'
          break

        case 2:
          hash = '#completed'
          break

        default:
          break
      }

      this.$router.replace({ hash, query: null }).catch(() => {})
    },
    nextTab() {
      this.tab++
      this.checkTab()
    }
  }
}
</script>

<style scoped>
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height: 4px;
  top: 36px;
  left: 0px;
  right: 0px;
}
</style>